// theme constant
export const gridSpacing = 3;
export const drawerWidth = 280;
export const minimizedDrawerWidth = 100;
export const appDrawerWidth = 320;
